import { render, staticRenderFns } from "./Terrain.vue?vue&type=template&id=2ff0555e&scoped=true&"
import script from "./Terrain.vue?vue&type=script&lang=js&"
export * from "./Terrain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff0555e",
  null
  
)

export default component.exports